import { FaceAmountComponent } from "@goodfill/domain-properties-components";
import { formatPercentage } from "@goodfill/format-number";
import { sortByKeys, SortColumn } from "@goodfill/sort";
import { capitalizeFirstLetter } from "@goodfill/string";
import { calculateRandomColorFromSeed } from "@goodfill/color";
import { useMemo, useState } from "react";
import { Span, Table, TableHeader, TableRow } from "../../../../../ui-components";
import { PortfolioDistributionGroupBy } from "./createPortfolioDistribution";
import { PortfolioPart } from "./PortfolioDistribution";
import { getPortfolioDistributionLegendTableComparator } from "./PortfolioDistributionLegendTableComparator";

type SortableKeys = keyof PortfolioPart;

export const PortfolioDistributionLegendTable = ({
  rows,
  groupBy,
}: { rows: PortfolioPart[]; groupBy: PortfolioDistributionGroupBy }) => {
  const [sortColumns, setSortColumns] = useState<readonly SortColumn<SortableKeys>[]>([]);

  const header: TableHeader<keyof PortfolioPart>[] = [
    { key: "id", value: "" },
    { key: "label", value: capitalizeFirstLetter(groupBy) },
    { key: "percentage", value: "%" },
    { key: "absolute", value: "Total Amount" },
  ];

  const rowsWithColor = rows.map((row) => ({
    ...row,
    color: calculateRandomColorFromSeed(row.id, "blue"),
  }));

  // TODO: abstract sortedRows/summaryRows into useSortedRows(rows) and useSummaryRows(rows), respectively
  const sortedRows = useMemo(
    () => sortByKeys(rowsWithColor, sortColumns, getPortfolioDistributionLegendTableComparator),
    [rowsWithColor, sortColumns],
  );

  const tableRows: TableRow[] = sortedRows.map((row) => {
    return {
      data: [
        <div
          style={{
            width: "12px",
            height: "12px",
            backgroundColor: row.color,
          }}
        />,
        <Span font="light">{row.label}</Span>,
        <Span font="normal">{formatPercentage({ value: row.percentage, numDecimals: 2 })}</Span>,
        <Span font="normal">
          <FaceAmountComponent value={row.absolute} />
        </Span>,
      ],
    };
  });

  return (
    <div className="flex flex-col gap-2 my-4">
      <Table
        header={header}
        rows={tableRows}
        onSortChange={(key, i, direction) => {
          setSortColumns([{ columnKey: key, direction: direction }]);
        }}
      />
    </div>
  );
};
